import { MediaListItem } from "@jconradi/tutu-porn-api-client/src/users"
import Lightbox from "yet-another-react-lightbox";
import "yet-another-react-lightbox/styles.css";
import { useState } from "react";
import Fullscreen from "yet-another-react-lightbox/plugins/fullscreen";
import Zoom from "yet-another-react-lightbox/plugins/zoom";
import { BunnyCdnImage } from "../../Image/BunnyCdnImage";

export const ImageMediaItem = ({ media }: { media: MediaListItem }) => {
    const [ open, setOpen ] = useState(false);

    return (
        <>
        <BunnyCdnImage loading="eager" onClick={() => setOpen(true)} fill={true} className="object-contain  w-full h-full"  src={media.urls.poster} alt={`Photo for ${media.slug}`} />
        <Lightbox open={open} close={() => setOpen(false)}
        render={{
            iconNext: () => { return null },
            iconPrev: () => { return null },
        }}
        plugins={[Fullscreen, Zoom]}
        zoom={{
            maxZoomPixelRatio: 5,
            scrollToZoom: true
        }}
        slides={[{ src: media.urls.poster!}]} />
        </>
    )
}